export default __webpack_public_path__ + "static/media/musicPlayer-img.11926ae9.png";